module.exports = __webpack_public_path__ + "static/fonts/Inter-Medium.ed533866.ttf";